import { render, staticRenderFns } from "./messageRecordReplyElement.vue?vue&type=template&id=51fbe900&scoped=true&"
import script from "./messageRecordReplyElement.vue?vue&type=script&lang=js&"
export * from "./messageRecordReplyElement.vue?vue&type=script&lang=js&"
import style0 from "./messageRecordReplyElement.vue?vue&type=style&index=0&id=51fbe900&prod&lang=scss&"
import style1 from "./messageRecordReplyElement.vue?vue&type=style&index=1&id=51fbe900&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fbe900",
  null
  
)

export default component.exports